module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAyElEQVQoU32R6xUBMRBG73ZAB0rYErYEJWwHlEAF6IAOqMCWoAQqoATn5swQyzF/kszkeyUN7+qABTAHLsAaOFbzsm2iMQOG6rJnL6/GoAQ4eADbkaJ9lV9VA67Avpq1QfATYFN2V5UswZKo8qVgw4GhDWyGE7AEVBJYiNJSHwBVBPgA9ry4AXYBGAT4jBku7UimvTNwCEVVWwGyCXDNyj+5Rd9ZUUvAx0sEo/4nQaayVvvMMP5Qz+bR7h2YRobuH0DP2kjLkgxP6bgx/PqycOEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shape1.png
// module id = aufi
// module chunks = 2